<template>
  <div>
    <div class="w-full vx-col mb-base">
      <vs-card title="Add New Customer" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
           <div class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-left">
              <h4>Good Issue</h4>
          </div>
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
            <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="submitForm">Process</vs-button>
            <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="getTemplate({endpoint: 'support/gi', name: 'gi-template'})">Download Template</vs-button>

            </div>
        </div>
        <div class="mt-6 vx-row">
          <div class="w-full vx-col md:w-1/4">

              <label class="vs-input--label"><b>File</b></label>

          </div>
        </div>

        <div class="mt-6 vx-row">

          <div class="w-full vx-col md:w-1/4">

            <input
                type="file"
                id="pod_file"
                v-on:change="handleFileUpload($event)"
            />

            </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  data() {
    return {
      isLoading: false,
      isForm: false,
      file:null,
      fileName: "Select file (.xslx, .xls)",
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    handleFileUpload(event){
        this.file = event.target.files[0];
    },
    // submitForm() {
    //   if(this.reference == ''){
    //     this.$vs.notify({
    //           color: "danger",
    //           title: "Error",
    //           text: "No Reference is required"
    //       });

    //       return false;
    //   }
    //   this.isLoading = true;
    //   this.$http.post("support/resend_awb_confirm_status", {
    //       reference: this.reference
    //   })
    //   .then(res => {
    //       this.isLoading = false;
    //       const message = res.data.message ? res.data.message : 'Success.'
    //       this.$vs.notify({
    //           color: "success",
    //           title: "Success",
    //           iconPack: "feather",
    //           icon: "icon-check",
    //           text: message
    //       });

    //       setTimeout(() => {
    //           window.location.reload()
    //       }, 200);
    //   })
    //   .catch(error => this.handleError(error));
    // },
    submitForm(){
        this.isLoading = true;

        let file = new FormData();
        file.append("file",this.file);

        this.$http.post('support/upload_gi', file,{
        headers: {
            "Content-Type": "multipart/form-data"
        },
        })
         .then(res => {
          this.isLoading = false;
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
              color: "success",
              title: "Success",
              iconPack: "feather",
              icon: "icon-check",
              text: message
          });

          setTimeout(() => {
              //window.location.reload()
          }, 200);
      })
      .catch(error => this.handleError(error));
    },
  },
  mounted() {
  }
};
</script>
